import { Component, EventEmitter, input, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { v4 as uuidv4 } from 'uuid';
import { ModalService } from '../../services/modal.service';
import { IconsComponent } from '../icons/icons.component';
import { FormControl } from '@angular/forms';
import { TabComponent } from "../tab/tab.component";

@Component({
  selector: 'mg-toggle',
  standalone: true,
  imports: [CommonModule, IconsComponent, TabComponent],
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
})
export class ToggleComponent implements OnInit {
  private _active = false;
  @Input()
  set active(value: boolean) {
    this._active = value;
    this.value = value;
  }
  get active(): boolean {
    return this._active;
  }
  @Input() value = false;
  @Input() isReversed = false;
  @Input() position: 'left' | 'right' | 'center' | 'space-between' = 'center';
  @Output() activeChange = new EventEmitter<boolean>();
  @Input() disabled = false;
  @Input() textHelper = '';

  @Input()
  label!: string;
  @Input() id = '';
  @Input() idModal!: string;
  @Input() control!: FormControl;
  badgeText = input<string | undefined>()
  /** Emitted when the badge is clicked. Does not change the toggle state. */
  @Output() badgeClick = new EventEmitter<void>();

  constructor(private modalService: ModalService) { }

  onBadgeClick(event: Event) {
    event.stopPropagation();
    if (this.disabled || this.control?.disabled) return;

    this.badgeClick.emit();
  }

  openWarningModal() {
    this.modalService.open(this.idModal);
  }

  toggle() {
    if (this.disabled || this.control?.disabled) return;

    this.value = !this.value;
    this.active = !this.active;

    if (this.control) {
      const newValue = !this.control.value;
      this.control.setValue(newValue);
    }

    this.activeChange.emit(this.value);
  }

  ngOnInit() {
    if (!this.id) this.id = `toggle-${uuidv4()}`;
  }
}
